import { formatTimeInterval, type TimeIntervalFormat } from '@/shared/lib';

/**
 * Форматирует диапазон времени фразы транскрипта в действующем формате отображения времени;
 * границы принимаются в миллисекундах — в них их отдаёт транскрипт.
 *
 * Обе метки диапазона идут через `formatTimeInterval` — той же записью, что и таймкоды
 * комментариев, с которыми пользователь сопоставляет их на одном экране.
 *
 * Если `finishedAt` не задан, возвращается одиночная метка начала.
 */
export const formatPhraseTimeRange = (
  startedAt: number,
  finishedAt: number | null | undefined,
  format: TimeIntervalFormat,
): string => {
  const startSec = Math.max(0, Math.floor(startedAt / 1000));
  const finishSec = finishedAt != null && finishedAt >= startedAt ? Math.floor(finishedAt / 1000) : null;

  if (finishSec == null) {
    return formatTimeInterval(startSec, format);
  }
  return `${formatTimeInterval(startSec, format)} - ${formatTimeInterval(finishSec, format)}`;
};
